
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import listado from './lista-listado.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
        }
    } )

    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }
        public get Items() { return this.Controlador.Buscador.Items; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {

        }


        public Busqueda: string = '';

        public Buscar( forzar?: boolean )
        {
            if ( forzar )
                this.Busqueda = '';
           this.Controlador.Buscador.Filtros.Busqueda = this.Busqueda;
           this.Controlador.Buscador.Buscar( 1, false );
        }
    }
